import React, { useEffect, useState } from "react";
import axios from "../../axiosInstance";
import PropTypes from "prop-types";
import NullImage from "../../components/Images/nullImage.png";
import Loading from "../Loading/Loading";
import NewsItem from "../NewsItem/NewsItem";
import { v4 as uuidv4 } from "uuid";
import { Col, Row, Button } from "react-bootstrap";
import NavBar from "../NavBar/NavBar";
import RunningHeader from "../RunningHeader/RunningHeader";
import AdsBanner from "../AdsBanner/AdsBanner";
import Footer from "../Footer/Footer";
import AdsBanner_mid from "../AdsBanner/AdsBanner_mid";
import "./news.css";

function News(props) {
  const { newscategory } = props;
  const [articles, setArticles] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalArticles, setTotalArticles] = useState(0); // Track total articles
  const [loading, setLoading] = useState(true);
  const [hasError, setHasError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const district=localStorage.getItem('district');
  const articlesPerPage = 16;

  const capitalize = (string) => string.charAt(0).toUpperCase() + string.slice(1);
  const category = newscategory;
  const title = capitalize(category);
  document.title = `${capitalize(title)} - News`;

  // Fetch news articles dynamically
  const fetchNews = async () => {
    try {
      setLoading(true);

      // Calculate pagination range
      const start = (currentPage - 1) * articlesPerPage + 1;
      const end = currentPage * articlesPerPage;
      const range = `${start}-${end}`;

      // API request with range and search query
      const response = await axios.get(`/api/news/readall`, {
        params: {
          range, // Send pagination range
          search: searchQuery, // Send search query if applicable
          district,
        },
      });

      const parsedData = response.data.districtNews;

      setArticles(parsedData || []);
      setTotalArticles(response.data.totalCount); // Replace with actual total count from the API
      setLoading(false);
    } catch (error) {
      console.error("Error fetching news:", error);
      setHasError(true);
      setErrorMessage(error.message || "An error occurred while fetching news.");
      setLoading(false);
    }
  };

  // Fetch data whenever `currentPage` or `searchQuery` changes
  useEffect(() => {
    fetchNews();
  }, [currentPage, searchQuery, district]);

  // Pagination handlers
  const handleNextPage = () => {
    if (currentPage < Math.ceil(totalArticles / articlesPerPage)) {
      setCurrentPage((prevPage) => prevPage + 1);
    }
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prevPage) => prevPage - 1);
    }
  };

  // Utility function to generate slug from title
  const generateSlug = (title) => {
    return title
      .toLowerCase()
      .replace(/[^a-z0-9\s-]/gi, "")
      .trim()
      .replace(/\s+/g, "-");
  };

  // Insert ads into the news list
  const insertAdsSeparately = () => {
    const adsEvery = 4; // Place an ad after every 4 articles
    const result = [];

    articles.forEach((article, index) => {
      result.push(
        <Col
          sm={12}
          md={6}
          lg={4}
          xl={3}
          style={{ marginBottom: "20px" }}
          key={article.newsId || uuidv4()}
        >
          <NewsItem
            title={article.title}
            shortDescription={article.shortDescription}
            description={article.description}
            published={article.createdAt}
            channel={article.reporterName || "Unknown Channel"}
            alt="News image"
            imageUrl={article.image || NullImage}
            urlNews={`/news/${article.newsId}`} // Use the generated slug here
          />
        </Col>
      );

      if ((index + 1) % adsEvery === 0) {
        // Insert an ad after every 4 articles
        result.push(
          <div
            key={`ad-${index}`}
            className="ad-banner-container-mid"
            style={{ marginBottom: "20px" }}
          >
            <AdsBanner_mid placement="Middle" page="Home" />
          </div>
        );
      }

    });

    return result;
  };

  return (
    <>
      {loading ? (
        <Loading />
      ) : hasError ? (
        <div>{errorMessage}</div>
      ) : (
        <>
          <NavBar searchQuery={searchQuery} setSearchQuery={setSearchQuery} />
          <RunningHeader />
          <AdsBanner placement="Header" page="Home" />

          {/* Main news container */}
          <Row className="justify-content-center">{insertAdsSeparately()}</Row>

          {/* Pagination controls */}
          <div
            className="pagination-controls d-flex justify-content-center align-items-center"
            style={{ marginTop: "20px" }}
          >
            <Button
              onClick={handlePrevPage}
              disabled={currentPage <= 1}
              className="mx-2"
            >
              Previous
            </Button>
            <span className="mx-2" style={{ fontSize: "16px" }}>
              Page {currentPage} of {Math.ceil(totalArticles / articlesPerPage)}
            </span>
            <Button
              onClick={handleNextPage}
              disabled={currentPage >= Math.ceil(totalArticles / articlesPerPage)}
              className="mx-2"
            >
              Next
            </Button>
            
          </div>
          <AdsBanner placement="Footer" page="Home" />
          <Footer />
        </>
      )}
    </>
  );
}

News.defaultProps = {
  country: "us",
  newscategory: "general",
};

News.propTypes = {
  country: PropTypes.string,
  newscategory: PropTypes.string,
};

export default News;